import { TextInput } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { SectionTitle } from '../../../../../components/text';
import { useValidations } from '../../../../../hooks/useValidations';
import { TranslationsKeys } from '../../../../../locales/translations';
import { formatToOnlyPositiveIntegers } from '../../../../../utils/currency';
import { CourseFormFields } from '../../types';

type CourseOptionalDetailsSectionProps = {
  readOnly?: boolean;
};

/**
 * HU 15624 — Sección "Detalles opcionales" del tab Administrativo
 * (FRD §1.3.a). Agrupa los 3 campos escalares de horas a nivel asignatura:
 *
 *   - totalHours: horas totales de la asignatura completa.
 *   - presentialPedagogicalHours: horas presenciales y pedagógicas.
 *   - weeklyHours: horas semanales (NUEVO en HU 15624).
 *
 * La tabla "Horas y Asistencia Requerida por Componente" se renderiza
 * en `CourseAttendanceSection`, también dentro de esta sección.
 */
const CourseOptionalDetailsSection = ({
  readOnly = false,
}: CourseOptionalDetailsSectionProps) => {
  const { t } = useTranslation(TranslationsKeys.ACADEMIC_OFFER_COURSES_UPDATE);
  const { rulesPatternNumeric } = useValidations();

  const { control } = useFormContext<CourseFormFields>();

  return (
    <Row>
      <Col xs={12} className="pt-4 pb-3">
        <SectionTitle text={t(`courseHoursSubsection`)} />
      </Col>
      <Col xs={12} lg={4}>
        <TextInput
          name="totalHours"
          label={t('totalHours')}
          control={control}
          rules={{
            pattern: rulesPatternNumeric,
          }}
          formatter={formatToOnlyPositiveIntegers}
          disabled={readOnly}
        />
      </Col>
      <Col xs={12} lg={4}>
        <TextInput
          name="presentialPedagogicalHours"
          label={t('presentialPedagogicalHours')}
          control={control}
          rules={{
            pattern: rulesPatternNumeric,
          }}
          formatter={formatToOnlyPositiveIntegers}
          disabled={readOnly}
        />
      </Col>
      <Col xs={12} lg={4}>
        <TextInput
          name="weeklyHours"
          label={t('weeklyHours')}
          control={control}
          rules={{
            pattern: rulesPatternNumeric,
          }}
          formatter={formatToOnlyPositiveIntegers}
          disabled={readOnly}
        />
      </Col>
    </Row>
  );
};

export default CourseOptionalDetailsSection;
